import Swal from 'sweetalert2'
import { deleteArticuloPrecio } from '../../../Services/articuloPrecioService'

const useDeleteArticuloPrecio = (setIsLoad) => {
  const eliminar = async (articuloId, listaId) => {
    const result = await Swal.fire({
      title: '¿Estás seguro de eliminar?',
      text: '¡Un artículo eliminado no se puede recuperar!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar!',
      cancelButtonText: 'Cancelar',
    })
    if (result.value) {
      try {
        await deleteArticuloPrecio(articuloId, listaId)
        setIsLoad(true)
        await Swal.fire('Eliminado!', 'El artículo fue eliminado.', 'success')
      } catch (err) {
        await Swal.fire({
          type: 'error',
          title: 'Error',
          text: 'Hubo un error, vuelve a intentar!',
        })
      }
    }
  }
  return eliminar
}

export default useDeleteArticuloPrecio